<template>
  <div class="wrapper">
    <div class="berkah1000" v-html="content"></div>
    <div class="footer">
      <img src="/img/footersss.svg" />
    </div>
  </div>
</template>

<script>
import axios from '@/utils/masjedapi';
export default {
  name: 'sklivin1000berkah',
  data() {
    return {
      content: '',
    };
  },
  mounted() {
    this.fetchSK();
  },
  methods: {
    async fetchSK() {
      const response = await axios.get('/sklivin1000berkah');
      const { data } = response.data;
      this.content = data.content;
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}

.wrapper {
  display: block;
  position: relative;
  width: 100%;
  max-width: 480px;
  margin: 0px auto;
  box-sizing: border-box;
  top: 0px;
  min-height: calc(100vh - 0px);
  padding-top: 20px;

  .footer {
    display: block;
    img {
      width: 100%;
    }
  }
}
</style>
